// extracted by mini-css-extract-plugin
export default {"addToCartControl":"qX-z","giftCard":"rX-z","btnContainer":"sX-z","cartButton":"tX-z","disabled":"uX-z","stockMessage":"vX-z"};